import React, { createContext, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useFindFormTemplates } from './FormTemplate.hooks';
import { FormProvider } from './FormContext';
import { useUpdateFormTemplate } from '.';
import { useEntityContext } from '@sierralabs/entity-ui';
import { BooleanParam, useQueryParam } from 'use-query-params';
export const FormBuilderContext = createContext(null);
export const useFormBuilderContext = (params) => {
    const context = useContext(FormBuilderContext);
    if (!context && !(params === null || params === void 0 ? void 0 : params.ignoreUndefined)) {
        throw new Error('useFormBuilderContext must be used within the context of the FormBuilderProvider component');
    }
    return context;
};
export const FormBuilderProvider = props => {
    var _a;
    const { elementPlugins, children } = props;
    const [showDeleted] = useQueryParam('show-deleted', BooleanParam);
    // handle editing form state
    const [selectedForm, setSelectedForm] = useState();
    // Load all forms
    const findFormTemplatesApi = useFindFormTemplates();
    const { formTemplateList, findFormTemplates } = findFormTemplatesApi;
    useEffect(() => findFormTemplates({ limit: 1000, includeDeleted: showDeleted }), [findFormTemplates, showDeleted]);
    // set up API calls for saving
    const { updatedFormTemplate, isUpdating: isUpdatingFormTemplate, updateError: updateFormTemplateError, updateFormTemplate } = useUpdateFormTemplate((selectedForm === null || selectedForm === void 0 ? void 0 : selectedForm.id) || 0);
    // const {
    //   updatedResult,
    //   isUpdating: isUpdatingFormSchema,
    //   updateError: updateFormSchemaError,
    //   applyFormSchemaDeltas
    // } = useApplyFormSchemaDelta(formTemplate?.formSchema.id || 0);
    // // set up state
    const timeoutRef = useRef(0);
    // const entitySchemaDeltasRef = useRef<Delta[]>([]);
    const [isQueued, setIsQueued] = useState(false);
    // get entity schema
    const { entities } = useEntityContext();
    const entitySchema = useMemo(() => entities === null || entities === void 0 ? void 0 : entities.find(e => { var _a; return e.name === ((_a = selectedForm === null || selectedForm === void 0 ? void 0 : selectedForm.entity) === null || _a === void 0 ? void 0 : _a.name); }), [entities, (_a = selectedForm === null || selectedForm === void 0 ? void 0 : selectedForm.entity) === null || _a === void 0 ? void 0 : _a.name]);
    // const [entitySchema, setEntitySchema] = useState(
    //   formTemplate?.formSchema?.config
    // );
    // // set entity schema state after form template loads
    // useEffect(() => {
    //   if (formTemplate?.formSchema) {
    //     setEntitySchema(formTemplate.formSchema.config);
    //   }
    // }, [formTemplate]);
    // // update entity schema state after it is saved
    // useEffect(() => {
    //   if (updatedResult) {
    //     setEntitySchema(entitySchema => {
    //       if (!entitySchema) return entitySchema;
    //       const trackChanges = new TrackChanges(entitySchema);
    //       return trackChanges.final;
    //     });
    //   }
    // }, [updatedResult]);
    // set progress notification spinner
    useEffect(() => {
        if (
        // updatedResult ||
        updatedFormTemplate ||
            updateFormTemplateError // ||
        // updateFormSchemaError
        ) {
            setIsQueued(false);
        }
    }, [
        updateFormTemplateError,
        // updateFormSchemaError,
        // updatedResult,
        updatedFormTemplate
    ]);
    console.log('selectedForm', selectedForm);
    return (React.createElement(FormBuilderContext.Provider, { key: (selectedForm === null || selectedForm === void 0 ? void 0 : selectedForm.id) || 'form', value: Object.assign(Object.assign({}, findFormTemplatesApi), { selectedForm,
            setSelectedForm }) },
        React.createElement(FormProvider, { entitySchema: entitySchema, elementPlugins: elementPlugins, formStateNode: selectedForm === null || selectedForm === void 0 ? void 0 : selectedForm.config, onEditSchema: trackChanges => {
                // const deltas = trackChanges.commit();
                // console.log('onEditSchema deltas to save', deltas);
                // entitySchemaDeltasRef.current.push(...deltas);
                // applyFormSchemaDeltas(
                //   deltas.map(delta => {
                //     // make a copy and need to prefix with "config." for formSchema saving
                //     delta = { ...delta, path: `config.${delta.path}` };
                //     return delta;
                //   })
                // );
            }, onEdit: trackChanges => {
                const deltas = trackChanges.commit();
                console.log('onEdit deltas to save', deltas);
                setIsQueued(true);
                clearTimeout(timeoutRef.current);
                // onEdit?.(trackChanges.final);
                timeoutRef.current = setTimeout(() => {
                    updateFormTemplate({ config: trackChanges.final });
                    // updateFormTemplateConfig(deltaQueue);
                }, 1000);
            } }, children)));
};
//# sourceMappingURL=FormBuilderContext.js.map